import { useQuery } from 'react-query'

import { API_URL } from 'src/constants'

export function useGetPage(slug: string) {
    return useQuery(slug, () =>
        fetch(`${API_URL}/page/${slug}`).then((res) => res.json())
    )
}
